type Props = { size?: number };

export function NiceSailboatSVG({ size = 72 }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 128 128"
      className="opacity-85 drop-shadow-[0_8px_18px_rgba(0,0,0,0.35)] boat-sway"
      aria-hidden="true"
    >
      <defs>
        {/* palette via css vars so it matches your theme */}
        <linearGradient id="hullGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--accent,#1B3B7A)" />
          <stop offset="100%" stopColor="#0B0F17" />
        </linearGradient>
        <linearGradient id="sailGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#F2F6FF" />
          <stop offset="100%" stopColor="var(--accent-contrast,#A7C2FF)" />
        </linearGradient>
      </defs>

      {/* tiny wake */}
      <path
        d="M22 106 q16 10 34 0 q16 10 34 0"
        stroke="rgba(167,194,255,0.35)"
        strokeWidth="3"
        fill="none"
      />

      {/* hull */}
      <path
        d="M22 94 h84 l-8 10 q-18 8 -34 8 t-34 -8 l-8 -10 z"
        fill="url(#hullGrad)"
        stroke="rgba(10,20,35,0.65)"
        strokeWidth="1.5"
      />

      {/* mast */}
      <rect x="63" y="28" width="3" height="60" rx="1.5" fill="#E6ECF8" />

      {/* main sail */}
      <g className="sail-flap">
        <path
          d="M64 30 L64 88 L32 84 Z"
          fill="url(#sailGrad)"
          stroke="rgba(20,36,64,0.35)"
          strokeWidth="1"
        />
        {/* jib */}
        <path
          d="M64 44 L96 84 L64 84 Z"
          fill="rgba(167,194,255,0.9)"
          stroke="rgba(20,36,64,0.35)"
          strokeWidth="1"
        />
      </g>

      {/* flag */}
      <path
        className="flag-wave"
        d="M66 28 L84 34 L66 38 Z"
        fill="var(--accent,#1B3B7A)"
      />
    </svg>
  );
}
